import React from 'react';
import { Box } from '@mui/material';
import { lightGreen } from '@mui/material/colors';
import { CallMade, CallReceived } from '@mui/icons-material';

interface Props {
  isInternal: boolean;
}

export const ActionDirection = ({ isInternal }: Props) => {
  return (
    <Box
      sx={{
        right: -4,
        bottom: -4,
        display: 'flex',
        padding: '0.10rem',
        position: 'absolute',
        alignItems: 'center',
        borderRadius: '100%',
        justifyContent: 'center',
        border: '1px solid white',
        backgroundColor: lightGreen[400],
      }}
    >
      {isInternal ? (
        <CallReceived sx={{ fontSize: 16, color: 'white' }} />
      ) : (
        <CallMade sx={{ fontSize: 16, color: 'white' }} />
      )}
    </Box>
  );
};
